import { render, staticRenderFns } from "./srViewingAs.vue?vue&type=template&id=5a4153b2&scoped=true"
import script from "./srViewingAs.vue?vue&type=script&lang=js"
export * from "./srViewingAs.vue?vue&type=script&lang=js"
import style0 from "./srViewingAs.vue?vue&type=style&index=0&id=5a4153b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4153b2",
  null
  
)

export default component.exports